import HttpClientToken from '../../services/HttpClientToken';

import { defaultEstado, EstadoProps } from '../../interfaces/catalogos/EstadoInterface';

export const Estados = () => {

    return new Promise<EstadoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Estado/', token)
            .then( ({ data } : { data : EstadoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerEstados = () => {

    return new Promise<EstadoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Estado/ObtenerEstados/', token)
            .then( ({ data } : { data : EstadoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarEstado = ( params: EstadoProps ) => {

    return new Promise<EstadoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Estado/Actualizar', params, token)
            .then( ({ data } : { data : EstadoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultEstado } );
            });

        }

    });

}

export const AgregarEstado = ( params: EstadoProps ) => {

    return new Promise<EstadoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Estado/Agregar', params, token)
            .then( ({ data } : { data : EstadoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultEstado } );
            });

        }

    });

}
